<style src="./Index.scss"></style>
<template>
  <div class="content-align">


    <!--<div id="title" class="hero is-medium">
      <section class="hero-body">
        <Title/>
      </section>
    </div>-->
    <div id="index" class="hero is-medium">
      <div class="fullscreen-bg">
        <video autoplay muted loop playsinline  class="fullscreen-bg__video">
            <source src="https://raw.githubusercontent.com/acme-development/evic2018v2/develop/src/assets/usach.mp4" type="video/mp4">
        </video>
      </div>
      <section class="hero-body">
        <Title/>
        <Minifooter id="minifooter"/>
      </section>
    </div>
    <div id = "about" class="hero is-medium">
      <section class="about hero-body">    
        <About/>
      </section>
    </div>

    <div id="program" class="hero is-medium">
      <section class="hero-body">
        <Program/>
      </section>
    </div>

    <div id="experts" class="hero is-medium">
      <section class="hero-body">
        <Experts/>
      </section>
    </div>
    <div id="exhibitors" class="hero is-medium">
      <section class="hero-body">
        <Exhibitors/>
      </section>
    </div>

    <div id="inscription" class ="hero is-medium">
      <section class="hero-body">
        <Inscription/>
      </section>
    </div>
    <div id="scholarship" class="hero is-medium">
      <section class ="hero-body">
        <Scholarship/>
      </section>
    </div>
    <div id="competition" class="hero is-medium">
      <section class="hero-body">
        <Competition/>
      </section>
    </div>
    <div id="ubication" class ="hero is-medium" >
      <section class="hero-body">
          <Ubication/>
      </section>
    </div>
    <div id ="organization" class="hero is-medium" >
      <section class="hero-body">
        <Organization/>
      </section>
    </div>
    <div id ="sponsors" class="hero is-medium">
        <section class="hero-body">
          <Sponsors/>
        </section>
    </div>
  </div>
</template>

<script>
import About from "../about/About";
import Title from "../title/Title";
import Program from "../program/Program";
import Ubication from "../ubication/Ubication";
import Experts from "../experts/Experts";
import Competition from '../competition/Competition';
import Inscription from '../inscription/Inscription';
import Exhibitors from '../exhibitors/Exhibitors';
import Sponsors from '../sponsors/Sponsors';
import Organization from '../organization/Organization';
import Minifooter from '../title/minifooter/Minifooter';
import Scholarship from '../scholarship/Scholarship';
export default {
  name: 'Index',
  components: {
    About, 
    Title,
    Program,
    Ubication,
    Experts,
    Competition,
    Inscription,
    Exhibitors,
    Sponsors,
    Organization,
    Minifooter,
    Scholarship,
    },
  created(){
    //console.log("He sido llamado");
  },
  mounted() {
    //console.log("He sido llamado");
  },
}
</script>




// WEBPACK FOOTER //
// src/components/index/Index.vue